import {useLayoutEffect, useRef} from 'react';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {setAssistantContent} from '../coreSlice';
import {AssistantContent} from '../types';

export const useAssistant = (assistantContent: AssistantContent | null, when = true) => {
  const dispatch = useAppDispatch();
  const assistantContentRef = useRef(assistantContent);

  useLayoutEffect(() => {
    if (when) {
      dispatch(setAssistantContent(assistantContentRef.current));
      return () => {
        dispatch(setAssistantContent(null));
      };
    }
  }, [dispatch, when]);
};
